import { useState, useContext, useEffect } from "react";

import DataTable from "@shared-ui-components/DataTable";

import LocationContext from "@context/location/locationContext";
import { EmployeeShift } from "@shared-ui-components/DataTable/types";

import { getCustomExtraPath } from "@src/pages/Dashboard/RevenueDashBoard/TotalSales/helper";
import { useNavigate } from "react-router-dom";
import { getApiResponse } from "@src/utils/service";
import { SORTKEYMAP } from "@src/constants/DataTable";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import { message } from "@src/constants";
import { columns, filterOptions, refineData } from "./helper";

const ShiftInformationTable = ({ pagination }: { pagination: boolean }) => {
  const [type, setType] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [rowData, setRowsData] = useState<EmployeeShift[]>([]);

  const [pageNumber, setPageNumber] = useState(0);
  const navigate = useNavigate();
  const [sortBy, setSortBy] = useState({
    tableName: "clock_in",
    label: "Clock In",
    order: "desc",
  });
  const [{ locationState }] = useContext(LocationContext);

  const { property, store, revenueCenter, date } = locationState;
  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);
  const filterType = filterOptions.find((el) => el.label === type)?.value;

  const filters = {
    property,
    store,
    rvc: revenueCenter,
    date,
    filterBy: filterType || "",
  };

  const filter = getCustomExtraPath(filters);

  const url = `labour-shift-info${filter}&sort_by=${
    sortBy.tableName
  }&sort_order=${sortBy.order === "desc" ? "desc" : "asc"}&page=${
    pageNumber + 1
  }`;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage - 1);
  };

  const setLocalFilter = (changedtype: string, page: number) => {
    localStorage.setItem(
      "LabourShiftFilter",
      JSON.stringify({ filtertype: changedtype, pageNumber: page })
    );
    setType(changedtype);
  };

  const localRevenueFilter = localStorage.getItem("LabourShiftFilter");

  const handleTypeChange = (changedType: string) => {
    setRowsData([]);
    setIsLoading(true);
    setPageNumber(0);
    setType(changedType);
    setLocalFilter(changedType, pageNumber);
  };

  const sortHandler = (sortkey: string) => {
    const sortKeyObject = SORTKEYMAP.find(
      (el) => el.tableName === sortkey.toLowerCase()
    );
    setSortBy((prev) => {
      if (sortKeyObject) {
        return {
          tableName: sortKeyObject.label,
          label: sortkey,
          order: prev.order === "desc" ? "asc" : "desc",
        };
      }
      return prev;
    });
  };

  const handleNavigate = () => {
    navigate("/labour-dashboard/shift-information");
  };

  const handleLocalFilters = () => {
    if (localRevenueFilter !== null) {
      const localFilters = JSON.parse(localRevenueFilter);
      const localFilterType =
        localFilters.filtertype.length > 0
          ? localFilters.filtertype
          : "By Recent First";
      setType(localFilterType);
    } else {
      setType("By Recent First");
      setLocalFilter("By Recent First", pageNumber);
    }
  };

  useEffect(() => {
    setPageNumber(0);
    handleLocalFilters();
  }, [property, store, revenueCenter, date, localRevenueFilter]);

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const result = await getApiResponse(url);
        if (result?.data !== null) {
          const refinedData = refineData(result?.data);
          setRowsData(refinedData);
          setIsLoading(false);
        } else {
          showErrorToastSetState({
            errorMessage: result?.error || "",
            errorTitle: message.ERROR_MESSAGE_DASHBOARD,
            open: true,
          });
        }
        setIsLoading(false);
      } catch (err) {
        showErrorToastSetState({
          errorMessage: "",
          errorTitle: message.ERROR_MESSAGE_DASHBOARD,
          open: true,
        });
      }
    };
    if (filterType !== undefined) {
      getData();
    }
  }, [url, filterType]);

  return (
    <DataTable
      sortHandler={sortHandler}
      title="Shift Information"
      rowData={rowData}
      page={pageNumber}
      showPagination={pagination}
      sortBy={sortBy}
      handleNavigate={handleNavigate}
      handlePageChange={handleChangePage}
      handleTypeChange={handleTypeChange}
      type={type}
      isLoading={isLoading}
      dyColumns={columns}
      dropDownOptions={filterOptions}
    />
  );
};

export default ShiftInformationTable;
